var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"portal-modal",on:{"click":_vm.handleClick}},[_vm._t("portal-panel")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }